import styled from '@emotion/styled/macro';
import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Icon } from '../ui_elements/icons';
import { colors, zindex } from '../styles';

const paneStyles = css`
  flex: 1;
  padding-top: 22px;
  padding-bottom: 176px;
  position: relative;
`;

export const MultiPaneLayoutContainer = styled.div`
  width: 100%;
`;

export const MultiPaneLayoutPanesContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: ${(props) => (props.singlePaneMode ? 'column' : 'row')};
  flex-wrap: nowrap;
  min-height: 100vh;
  max-width: 1920px;
  align-content: stretch;
`;


function tabIcon(active, singlePaneMode) {
  if (active) {
    if (singlePaneMode) {
      return null;
    }

    return "content: '\\f105\\f105';";
  }

  return null;
}

export const StyledLink = styled(Link)`
  outline: 0;
  text-decoration: none;
`;

const lgActiveTabStyles = css`
  ${Icon} {
    color: ${colors.grey.primary};
  }
  background: #fcfcfc;
  &::before {
    content: ' ';
    width: 1px;
    background: #fcfcfc;
    position: absolute;
    top: 0;
    bottom: 0;
    left: -1px;
  }
`;

const lgNonActiveTabStyles = css`
  background-color: ${colors.white};
`;

const smActiveTabStyles = css`
  background-color: #fff;
  border-bottom: 1px solid transparent;
  border-left: 1px solid #eee;
`;

const smNonActiveTabStyles = css`
  background-color: #fcfcfc;
  border-bottom: 1px solid #eee;
`;

export const MultiPaneTabContainer = styled.div`
  font-size: 1rem;
  text-align: center;
  height: 40px;
  cursor: pointer;
  position: relative;

  ${(props) => (props.active ? lgActiveTabStyles : lgNonActiveTabStyles)}

  ${Icon} {
    color: ${colors.grey.primaryLight};
    margin-top: 8px;
    &::before {
      ${(props) => tabIcon(props.active, props.singlePaneMode)}
    }
  }

  @media (max-width: 1100px) {
    ${(props) => (props.active ? smActiveTabStyles : smNonActiveTabStyles)}

    ${Icon} {
      color: ${props => props.active ? colors.grey.primary : 'defaultColor'};
    }
  
    &::before {
      content: ${props => props.active ? "' '" : 'none'};
      width: ${props => props.active ? '1px' : '0'};
      background-color: ${props => props.active ? '#fcfcfc' : 'defaultColor'};
      position: ${props => props.active ? 'absolute' : 'static'};
      top: ${props => props.active ? '0' : 'auto'};
      bottom: ${props => props.active ? '0' : 'auto'};
      left: ${props => props.active ? '-1px' : 'auto'};
    }
  }


  &:hover {
    ${(props) =>
      props.active
        ? null
        : css`
            background: ${colors.grey.secondary};
          `}
    ${Icon} {
      color: ${colors.black};
    }
  }
`;

const singlePaneModeNavStyles = css`
  order: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;

  ${StyledLink} {
    display: inline-block;
    width: 100%;
    border-right: 1px solid ${colors.grey.secondary};
  }
`;

const multiPanelModeNavStyles = css`
  order: 3;

  ${MultiPaneTabContainer} {
    width: 40px;
    border-bottom: 1px solid ${colors.grey.secondary};
    border-right: 1px solid ${colors.grey.secondaryDark};
  }
`;

export const MultiPaneTabsList = styled.div`
  border-left: 1px solid ${colors.grey.secondaryDark};
  z-index: ${zindex.component.belowBase};

  ${(props) => (props.singlePaneMode ? singlePaneModeNavStyles : multiPanelModeNavStyles)}
`;

export const MultiPanePanes = styled.div`
  min-width: 55%;
  ${paneStyles}
  transition: all 0.3s ease-in-out;
  border-left: 1px solid ${colors.grey.secondaryDark};
`;

export const MainPane = styled.div`
  max-width: ${(props) => (props.expand ? '1000px' : '820px')};
  margin: 0 auto;
  transition: all 0.3s ease-in-out;
`;

export const MultiPaneLayoutSideBar = styled.div`
  box-shadow: -1px 0 3px 0 ${colors.grey.secondary}, inset 1px 0 0 ${colors.grey.secondaryDark};
  background: #fcfcfc;
  flex-basis: 320px;
  padding: 0px 30px;
  min-width: 300px;
  ${paneStyles}
  opacity: ${(props) => (props.show ? '1' : '0')};
  max-width: ${(props) => (props.show ? props.maxWidth : '0')};
  transform: ${(props) => (props.show ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out, opacity 1s ease-in-out;
`;

MultiPaneLayoutSideBar.propTypes = {
  show: PropTypes.bool,
  maxWidth: PropTypes.string,
};

MultiPaneLayoutSideBar.defaultProps = {
  show: null,
  maxWidth: '330px',
};
